import { OnChanges, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { QuestionarioService } from 'src/app/questionario-fgenergia/questionario.service';
import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityPagedRequestParameters, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { DadosClienteDTO, QuestionarioAvaliacaoProjetoDTO, TIPO_FILTRAGEM_CAMPO, TIPO_ORDENACAO } from 'src/app/model/questionario.model';
import { QuestionarioFgenergiaPesquisaComponent } from '../questionario-fgenergia-pesquisa/questionario-fgenergia-pesquisa.component';
import Utils from 'src/app/shared/fgi-utils';
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";



@Component({
    selector: 'app-questionario-fgenergia-listagem',
    templateUrl: './questionario-fgenergia-listagem.component.html',
    styleUrls: ['./questionario-fgenergia-listagem.component.scss'],
    standalone: false
})
export class QuestionarioFgenergiaListagemComponent implements OnInit, OnChanges {


  @Input() public questionarios: QuestionarioAvaliacaoProjetoDTO[] = [];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;

  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public aoExcluirQuestionario: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('body') msgPersonalizada: TemplateRef<any>;
  @ViewChild('botoes') botoesConfirmacao: TemplateRef<any>;


  public questionarioExclusao: number;
  public opcoesPaginacao: number[];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  constructor(
    private service: QuestionarioService,
    private modalService : BnModalMessageService,
    private router: Router) {
  }

  ngOnChanges(changes: SimpleChanges): void {

  }


  ngOnInit(): void {
    this.opcoesPaginacao = [10, 15, 20];
  }


  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  abrirModalExclusaoQuestionario(idToken : number){
    this.questionarioExclusao = this.questionarios.find(q => q.id === idToken).id;
    this.modalService.abrir("Confirmação", "" , "md", this.msgPersonalizada, this.botoesConfirmacao);
  }

  excluirQuestionario(){
    this.dismiss();
    this.aoExcluirQuestionario.emit(this.questionarioExclusao);
  }

  dismiss(){
    this.modalService.dismiss();
  }

  irParaAvaliacaoQuestionario(cnpj: string, token: string) {
    this.router.navigate(['questionario-eficiencia-energetica',cnpj,'token',token]);
  }

}
